<template>
  <div class="test1">
      
  </div>
</template>

<script>
export default {
  name: 'Main',
  components: {},
  data () {
      return {
         
      }
  },
  created() {

  },
  mounted(){
  },
  methods: {
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
  


// WEBPACK FOOTER //
// src/components/HelloWorld.vue